export default __webpack_public_path__ + "static/media/dental-error.00b142ea.svg";